// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as PnmIntGeoValidationApiModel$PorterinFeature from "../../api-model/PnmIntGeoValidationApiModel.mjs";

function apiModelToState(model) {
  return {
          pickup_geo_region_id: model.pickup_geo_region_id,
          drop_geo_region_id: model.drop_geo_region_id
        };
}

function execute(json) {
  return apiModelToState(DeccoUtils$Catalyst.resolveResult(PnmIntGeoValidationApiModel$PorterinFeature.t_decode(json), "PnmIntGeoValidationEntityMapper.res"));
}

export {
  apiModelToState ,
  execute ,
}
/* DeccoUtils-Catalyst Not a pure module */
